<script setup lang="ts">
import { computed, inject, onMounted, ref } from 'vue'
import Swal from 'sweetalert2'

const userStore = useUserStore()

const isLogin = ref(true)

const navbarShow = ref(false)
const windowWidth = ref(0)
const loginIsOpen = ref(false)

function loginOpen() {
  loginIsOpen.value = true
}

const auth = computed(() => {
  return {
    isLogin: isLogin.value,
  }
})

function toggleMobileNavbar() {
  navbarShow.value = !navbarShow.value
}

function logout() {
  Swal.fire({
    icon: 'success',
    text: '登出成功',
    timer: 500,
    timerProgressBar: true,
  })
  userStore.logOut()
}

function gotoRouter(targerType: string | null, routerName: string | null, titleName: string) {
  // emitter.emit('goto-router', { targerType, routerName, titleName })
}

onMounted(() => {
  windowWidth.value = window.innerWidth
  window.addEventListener('resize', () => {
    windowWidth.value = window.innerWidth
  })
})
</script>

<template>
  <div>
    <div id="top" class="header-space" />
    <header class="header">
      <div class="container clearfix">
        <div class="header-left clearfix">
          <div class="menuBtn" :class="{ active: navbarShow }" style="visibility: hidden;" @click.stop="toggleMobileNavbar()">
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <h1 class="header-logo" title="植根法律網">
            <a to="javascript:;" href="javascript:;" @click="gotoRouter(null, null, '植根法律網首頁')">
              <picture>
                <img data-cy="Logo" src="~/assets/images/logo-white.svg" alt="植根法律網">
              </picture>
            </a>
          </h1>
          <div class="header-search clearfix">
            <div class="header-search-input">
              <div class="header-search-input-content">
                <el-input style="visibility: hidden;" placeholder="請輸入關鍵字" />
              </div>
            </div>
          </div>
        </div>
        <div class="header-right clearfix">
          <div class="header-login">
            <a v-if="!auth.isLogin" data-cy="login" title="登入" href="javascript:;" @click="loginOpen">
              <i class="fas fa-sign-in-alt" />
              登入
            </a>
            <a v-else title="登出" data-cy="logout" href="javascript:;" @click="logout()">
              <i class="fas fa-sign-out-alt" />
              登出
            </a>
          </div>
        </div>
        <transition name="el-fade-in-linear">
          <nav v-show="navbarShow" class="navbar">
            <ul />
          </nav>
        </transition>
      </div>
    </header>
  </div>
</template>
